import { useMemo, useState } from 'react';

import config from '@/config';
import useGetSearchParams from "@/hooks/useGetSearchParams";
import useQuery from "@/hooks/useQuery";

const useNotifications = () => {
  const [hasBeenRead, setHasBeenRead] = useState(false);
  const [params] = useGetSearchParams();
  const [query] = useState(params ? params : { q: "" });
  
  const [markedNotifications, setMarkedNotifications] = useState([]);

  const { loading, queryData, loadMoreData, fetchData } = useQuery("notifications", `${config.apis.api.url}/notification`, query, {
    injectToken: true,
    invalidateWhen: ["NOTIFICATION_REFRESH"],
  });

  const hasNotifications = useMemo(() => {
    return queryData?.data?.data?.some(({ viewed }) => !viewed) && !hasBeenRead;
  }, [queryData, hasBeenRead]);

  return { hasBeenRead, 
    setHasBeenRead, 
    hasNotifications, 
    markedNotifications, 
    setMarkedNotifications, 
    loadMoreData, 
    loading, 
    queryData,
    fetch: fetchData
  };
};

export default useNotifications;
